import './notifications_btn.scss';

import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { shape, string } from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router';
import { Popover, PopoverBody } from 'reactstrap';

import api from '../../REST/api';
import * as Session from '../../utils/session';
import Notifications from '../Notifications';
import NotificationsBell from '../NotificationsBell';

class NotificationsPopup extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      errorMessage: '',
      isLoading: false,
      notifications: [],
      nextCursor: null,
    };
  }

  componentDidUpdate(prevProps) {
    if (
      get(this, 'props.location.pathname') !==
      get(prevProps, 'location.pathname')
    ) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ isOpen: false });
    }
  }

  fetchNotifications = () => {
    if (!Session.read()) {
      return;
    }

    this.setState({ isLoading: true });

    const queryParams = this.state.nextCursor
      ? { cursor: this.state.nextCursor.split('cursor=')[1] }
      : {};

    api
      .getNotifications({ search: queryParams })
      .then(({ results, next: nextCursor }) => {
        this.setState(state => ({
          notifications: state.notifications.concat(results),
          errorMessage: '',
          nextCursor,
          isLoading: false,
        }));
      })
      .catch(err => {
        this.setState({
          errorMessage: err.message,
          isLoading: false,
        });
      });
  };

  toggle = () => {
    if (this.state.isOpen) {
      this.closeDrawer();
    } else {
      this.openDrawer();
    }
  };

  openDrawer() {
    this.setState(
      {
        isOpen: true,
        notifications: [],
        nextCursor: null,
        errorMessage: '',
      },
      this.fetchNotifications(),
    );
  }

  closeDrawer() {
    this.setState({ isOpen: false });
  }

  render() {
    const { notifications, errorMessage, nextCursor, isLoading, isOpen } =
      this.state;

    return (
      <>
        <NotificationsBell onClick={this.toggle} isDrawerOpen={isOpen} />
        <Popover
          isOpen={this.state.isOpen}
          toggle={this.toggle}
          placement="bottom-end"
          target="notifications-comments-button"
          trigger="legacy"
        >
          <PopoverBody className="c-notifications-popover">
            {isEmpty(errorMessage) ? (
              <Notifications
                {...this.props}
                hasMoreNotifications={!!nextCursor}
                notifications={notifications}
                onLoadMore={this.fetchNotifications}
                isLoading={isLoading}
              />
            ) : (
              errorMessage
            )}
          </PopoverBody>
        </Popover>
      </>
    );
  }
}

NotificationsPopup.propTypes = {
  location: shape({ pathname: string.isRequired }).isRequired,
};

export default withRouter(NotificationsPopup);
